import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import CreateExams from "./components/CreateExams";
import ManageExams from "./components/ManageExams";
import YourCourses from "./components/YourCourses";
import UserList from "./components/UserList";
import ExamPage from "./components/ExamPage";
import CompletedExams from "./components/CompletedExams";
import EmployeeCompletedExams from "./components/EmployeeCompletedExams";
import IssuesPage from "./components/IssuesPage";
import PendingExams from "./components/PendingExams";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/dashboard/*" element={<Dashboard />}>
            {/* existing nested routes */}
            <Route path="create-exams" element={<CreateExams />} />
            <Route path="exams" element={<ManageExams />} />
            <Route path="your-courses" element={<YourCourses />} />
            <Route path="users" element={<UserList />} />
            <Route path="exam/:examId" element={<ExamPage />} />
            <Route path="completed-exams" element={<CompletedExams />} />
            <Route path="employee-completed-exams" element={<EmployeeCompletedExams />} />
            <Route path="issues" element={<IssuesPage />} />
            <Route path="pending-exams" element={<PendingExams />} />
            <Route index element={<YourCourses />} />
            
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
